import { createAction } from '@reduxjs/toolkit';

export const updateSelectionBatch = createAction('betslip/selectionDetails/updateSelectionBatch');
